import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import CanvasFieldItem from "./partials/CanvasFieldItem";
import CanvasStaticItem from "./partials/CanvasStaticItem";
import CanvasTabBar from "./partials/CanvasTabBar";
import "./canvas.css";
import { debug } from 'utils'
export default function Canvas({
  schema,
  setSchema,
  onDeleteField,
  selectedField,
  onSelectField,
  activeTabId,
  onActiveTabChange,
  setActiveTab
}) {
  const activeTab = activeTabId;
  const tabKeys = Object.keys(schema.properties || {});

  // 🔁 informe le parent du changement d’onglet actif

  /*
  useEffect(() => {
    onActiveTabChange?.(activeTab);
  }, [activeTab, onActiveTabChange]);
  */
  // 🧲 réorganisation des champs dans l’onglet actif uniquement
  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index) return;

    setSchema((prev) => {
      const clone = structuredClone(prev);
      const tab = clone.properties?.[activeTab];
      if (!tab?.properties) return prev;

      const keys = Object.keys(tab.properties);
      const [moved] = keys.splice(source.index, 1);
      keys.splice(destination.index, 0, moved);

      const reordered = {};
      keys.forEach((k) => (reordered[k] = tab.properties[k]));
      tab.properties = reordered;

      return clone;
    });
  };

  // 🗑️ suppression d’un champ
  const handleDeleteField = (fieldKey, fieldTitle) => {
    const confirmed = window.confirm(`Supprimer "${fieldTitle}" ?`);
    if (confirmed) onDeleteField(fieldKey);
  };

  const activeTabData = schema.properties?.[activeTab];
  const hasTabs = tabKeys.length > 0;

  return (
    <div>
      {/* 🧭 barre d’onglets */}
      <CanvasTabBar
        schema={schema}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onActiveTabChange={onActiveTabChange}
        setSchema={setSchema}
      />

      {/* 🧩 zone principale */}
      <div id="formbuilder-canvas" className="border rounded p-3 bg-white" style={{ minHeight: "60vh" }}>
        {!hasTabs ? (
          <div className="text-muted text-center p-4">
            Aucun onglet disponible
          </div>
        ) : !activeTabData ? (
          <div className="text-muted text-center p-4">
            Aucun onglet sélectionné
          </div>
        ) : (
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="fields">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    minHeight: "60vh",
                    background: snapshot.isDraggingOver
                      ? "rgba(0,123,255,0.05)"
                      : "transparent",
                    transition: "background 0.2s ease",
                  }}
                >

                  {Object.entries(activeTabData.properties || {}).length === 0 ? (
                    <div className="text-muted text-center p-4">
                      Aucun champ dans cet onglet
                    </div>
                  ) : (
                    Object.entries(activeTabData.properties).map(
                      ([fieldKey, field], index) => {

                        /** IMPORTANT : correction field.type → field["x-ui"] */
                        const uiType = field["x-ui"] || "";

                        /** Types statiques */
                        const isStatic = ["staticText", "staticTitle", "separator"]
                          .includes(uiType);
                        const isSelected = selectedField?.name === fieldKey;
                        return (
                          <Draggable
                            key={fieldKey}
                            draggableId={fieldKey}
                            index={index}
                          >
                            {(providedDrag) => (
                              <div
                                ref={providedDrag.innerRef}
                                {...providedDrag.draggableProps}
                                {...providedDrag.dragHandleProps}
                                className={`d-flex gap-3 p-2 mb-2 rounded field-block 
              ${isStatic ? "static-block" : "form-block"}
              ${isSelected ? "selected" : ""}
            `}
                                style={{
                                  ...providedDrag.draggableProps.style,
                                  cursor: "grab",
                                }}
                                onClick={() =>
                                  onSelectField({ id: fieldKey, ...field })
                                }>
                                <div className="flex-grow-1">
                                  {isStatic ? (
                                    <CanvasStaticItem field={field} />
                                  ) : (
                                    <CanvasFieldItem field={field} />
                                  )}
                                </div>

                                <div>
                                  <span
                                    className="small pointer"
                                    title="Supprimer cet élément"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleDeleteField(field.id, field.title);
                                    }}
                                  >
                                    🗑️
                                  </span>
                                </div>
                              </div>
                            )
                            }
                          </Draggable>
                        );
                      }
                    )
                  )}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </div>
    </div >
  );
}
